import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import SvgIcon from '../../components/SvgIcon/SvgIcon'; // 🧩 Nuevo import
import UserOne from '../../images/user/user-01.png';
import UserTwo from '../../images/user/user-02.png';
import UserThree from '../../images/user/user-03.png';
import UserFour from '../../images/user/user-04.png';

const DropdownMessage = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifying, setNotifying] = useState(true);

  const trigger = useRef<any>(null);
  const dropdown = useRef<any>(null);

  // 📦 Cierra al hacer click fuera
  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // ⌨️ Cierra con tecla Escape
  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  return (
    <li className="relative">
      <Link
        ref={trigger}
        onClick={() => {
          setNotifying(false);
          setDropdownOpen(!dropdownOpen);
        }}
        className="relative flex h-8.5 w-8.5 items-center justify-center rounded-full border-[0.5px] border-stroke bg-gray hover:text-primary dark:border-strokedark dark:bg-meta-4 dark:text-white"
        to="#"
      >
        {/* 🔴 Indicador de nuevos mensajes */}
        <span
          className={`absolute -top-0.5 -right-0.5 z-1 h-2 w-2 rounded-full bg-meta-1 ${
            notifying === false ? 'hidden' : 'inline'
          }`}
        >
          <span className="absolute -z-1 inline-flex h-full w-full animate-ping rounded-full bg-meta-1 opacity-75"></span>
        </span>

        {/* 💬 Ícono global del sistema */}
        <SvgIcon
          name="message"
          width={18}
          height={18}
          className="text-gray-700 dark:text-gray-200 duration-300 ease-in-out"
        />
      </Link>

      {/* 📩 Dropdown Start */}
      <div
        ref={dropdown}
        onFocus={() => setDropdownOpen(true)}
        onBlur={() => setDropdownOpen(false)}
        className={`absolute -right-16 mt-2.5 flex h-90 w-75 flex-col rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark sm:right-0 sm:w-80 ${
          dropdownOpen ? 'block' : 'hidden'
        }`}
      >
        <div className="px-4.5 py-3">
          <h5 className="text-sm font-medium text-bodydark2">Mensajes</h5>
        </div>

        <ul className="flex h-auto flex-col overflow-y-auto">
          {[ 
            { user: UserTwo, name: 'Mariya Desoja', msg: 'I like your confidence 💪', time: '2min ago' },
            { user: UserOne, name: 'Robert Jhon', msg: 'Can you share your offer?', time: '10min ago' },
            { user: UserThree, name: 'Henry Dholi', msg: 'I came across your profile and...', time: '1day ago' },
            { user: UserFour, name: 'Cody Fisher', msg: 'I’m waiting for your response!', time: '5days ago' },
          ].map((item, index) => (
            <li key={index}>
              <Link
                className="flex gap-4.5 border-t border-stroke px-4.5 py-3 hover:bg-gray-2 dark:border-strokedark dark:hover:bg-meta-4"
                to="/messages"
              >
                <div className="h-12.5 w-12.5 rounded-full overflow-hidden">
                  <img src={item.user} alt={item.name} />
                </div>

                <div>
                  <h6 className="text-sm font-medium text-black dark:text-white">
                    {item.name}
                  </h6>
                  <p className="text-sm text-gray-700 dark:text-gray-300">
                    {item.msg}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {item.time}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {/* 📩 Dropdown End */}
    </li>
  );
};

export default DropdownMessage;
